import React, { useState } from "react";
import {
  Box, Typography, TextField, Button, Grid,
  FormControl, RadioGroup, FormControlLabel, Radio,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";

import { createBusinessProcess } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import { COMPANY_ID } from "../../config/appConfig";

export default function ValueChainCreatePage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({
    businessProcessName: "",
    businessProcessDescription: "",
    businessProcessType: "CoreProcess",
    businessProcessClass: "Innovation",
    url: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createBusinessProcess({
        ...form,
        companyId: COMPANY_ID,
        businessDomainId,
        valueChain: true,
      });
      notify.success(t("message.create.success"));
      navigate(`/design/${businessDomainId}/value-chains`);
    } catch (err) {
      notify.apiError(err);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("valueChain.create.title")}
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              fullWidth
              required
              multiline
              label={t("valueChain.name")}
              name="businessProcessName"
              value={form.businessProcessName}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label={t("valueChain.description")}
              name="businessProcessDescription"
              value={form.businessProcessDescription}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                name="businessProcessClass"
                value={form.businessProcessClass}
                onChange={handleChange}
              >
                <FormControlLabel value="Innovation" control={<Radio />} label={t("businessProcess.class.innovation")} />
                <FormControlLabel value="Operation" control={<Radio />} label={t("businessProcess.classGroup.valueDelivery")} />
                <FormControlLabel value="Communication" control={<Radio />} label={t("businessProcess.class.communication")} />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              label={t("common.url")}
              name="url"
              value={form.url}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">
            {t("common.add")}
          </Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/value-chains`)}>
            {t("common.cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
